/*
 * Wishlist (client-side, localStorage).
 *
 * Mirrors the theme's own `recently-viewed` pattern: product ids are kept in
 * localStorage and the list page is painted through Shopify's Section Rendering
 * API (`/search?section_id=…&q=id:…`) so cards stay 100% Liquid.
 *
 * Public store: `$store.xWishlist`
 *   .has(id)        -> Boolean
 *   .toggle(id)     -> add / remove + persist + notify
 *   .count          -> Number (reactive)
 *   .render(id)     -> repaint `#wishlist-root` inside section `id`
 *   .clear()        -> empty the list (with confirm)
 */
(function () {
  var SCRIPT_ID = 'wishlist.js';
  if (window.Eurus && window.Eurus.loadedScript) {
    if (window.Eurus.loadedScript.has(SCRIPT_ID)) return;
    window.Eurus.loadedScript.add(SCRIPT_ID);
  }

  var STORAGE_KEY = 'victoria:wishlist';
  var MAX_ITEMS = 100;

  function readStorage() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      // Keep only positive integers, de-duplicated.
      return parsed
        .map(function (v) { return parseInt(v, 10); })
        .filter(function (v, i, arr) { return v > 0 && arr.indexOf(v) === i; })
        .slice(0, MAX_ITEMS);
    } catch (e) {
      return [];
    }
  }

  function writeStorage(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage full / disabled — nothing else we can do */
    }
  }

  document.addEventListener('alpine:init', function () {
    Alpine.store('xWishlist', {
      items: readStorage(),
      lastSectionId: null,

      get count() {
        return this.items.length;
      },

      has: function (id) {
        return this.items.indexOf(parseInt(id, 10)) !== -1;
      },

      toggle: function (id) {
        id = parseInt(id, 10);
        if (!id) return;
        var idx = this.items.indexOf(id);
        if (idx === -1) {
          this.items = [id].concat(this.items).slice(0, MAX_ITEMS);
        } else {
          this.items = this.items.filter(function (v) { return v !== id; });
        }
        writeStorage(this.items);
        window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: this.items.slice() } }));
      },

      clear: function () {
        if (!this.items.length) return;
        if (!window.confirm('¿Vaciar tu lista de deseos?')) return;
        this.items = [];
        writeStorage(this.items);
        window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: [] } }));
        if (this.lastSectionId) this.render(this.lastSectionId);
      },

      /* Repaint the list page. `sectionId` is the dynamic section id. */
      render: function (sectionId) {
        this.lastSectionId = sectionId;
        var root = document.getElementById('wishlist-root');
        if (!root) return;

        if (!this.items.length) {
          root.setAttribute('data-state', 'empty');
          return;
        }

        root.setAttribute('data-state', 'loading');
        var query = this.items
          .map(function (id) { return 'id:' + id; })
          .join(' OR ');
        var url =
          (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') +
          'search?section_id=' + encodeURIComponent(sectionId) +
          '&type=product&q=' + encodeURIComponent(query);

        fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error(res.status);
            return res.text();
          })
          .then(function (text) {
            var fresh = new DOMParser()
              .parseFromString(text, 'text/html')
              .getElementById('wishlist-root');
            if (!fresh) return;
            root.innerHTML = fresh.innerHTML;
            root.setAttribute('data-state', fresh.getAttribute('data-state') || 'ready');
            // Re-hydrate any Alpine controllers inside the injected cards.
            if (window.Alpine && typeof Alpine.initTree === 'function') {
              Array.prototype.forEach.call(root.children, function (child) {
                Alpine.initTree(child);
              });
            }
          })
          .catch(function () {
            root.setAttribute('data-state', 'error');
          });
      }
    });
  });

  /* Delegated remove button for cards painted on the list page. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-remove]');
    if (!btn) return;
    e.preventDefault();
    var store = window.Alpine && Alpine.store('xWishlist');
    if (!store) return;
    store.toggle(btn.getAttribute('data-wishlist-remove'));
    if (store.lastSectionId) store.render(store.lastSectionId);
  });
})();
